import {FC} from 'react'
import {ExtraAction} from '../types'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Dropdown} from 'react-bootstrap'

const Action: FC<{action: ExtraAction}> = ({action}) => {
  const intl = useIntl()

  const color = action.color || 'light-primary'

  const className = clsx(
    'btn',
    'btn-sm',
    'm-1',
    {
      [`btn-${color}`]: !!color,
    },
    action.className
  )

  let renderedButton = null

  const labelHasTranslation = action.label ? !!intl.messages[action.label] : false
  const labelTranslation =
    action.label && labelHasTranslation ? intl.$t({id: action.label}) : action.label

  if (action.type === 'link') {
    renderedButton = (
      <Link to={action.to} className={className} target={action.target || ''}>
        {labelTranslation}
      </Link>
    )
  }

  if (action.type === 'button') {
    renderedButton = (
      <button type='button' className={className} onClick={() => action.onClick()}>
        {labelTranslation}
      </button>
    )
  }

  if(action.type === 'dropdown') {
    const renderedItems = []

    for (let i = 0; i < action.items.length; i++) {
      const item = action.items[i]
      const labelHasTranslation = item.label ? !!intl.messages[item.label] : false
      var onClick = () => {};
      if (item.type === 'link') {
        onClick  = () => {
          window.open(`${item.to}`, item.target || '')
        }
      }
      if(item.type === 'button') {
        onClick = item.onClick
      }
      renderedItems.push(
        <Dropdown.Item onClick={onClick} key={i}>
          {labelHasTranslation ? intl.formatMessage({id: item.label}) : item.label}
        </Dropdown.Item>
      )
    }
    renderedButton = (
      <Dropdown>
        <Dropdown.Toggle
          variant='light-primary'
          id='dropdown-basic'
          className='d-inline-flex align-items-center justify-content-center btn btn-sm btn-light-primary'
        >
          {intl.formatMessage({id: action.label})}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {renderedItems}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  if (!renderedButton) return null

  return renderedButton
}

export default Action
